export const PRICE_CURRENCY = 'RUB';

const formatter = new Intl.NumberFormat('ru-RU', {
  style: 'currency',
  currency: PRICE_CURRENCY,
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export default (price: number) => formatter.format(price).replace('₽', 'руб.');
